import * as React from 'react'
import { PrismicProvider } from '@prismicio/react'
import { PrismicPreviewProvider } from 'gatsby-plugin-prismic-previews'

// Utils
import { repositoryConfigs } from './src/utils/prismicPreviews'
import htmlSerializer from './src/utils/htmlSerializer'
import { ExternalLink, InternalLink } from './src/utils/prismicLinkComponents'

import '@fontsource/lato/300.css'
import '@fontsource/lato/400.css'
import '@fontsource/oswald/400.css'
import '@fontsource/oswald/500.css'
import './src/styles/default.css'

export const wrapRootElement = ({ element }) => (
  <PrismicProvider externalLinkComponent={ExternalLink} internalLinkComponent={InternalLink} richTextComponents={htmlSerializer}>
    <PrismicPreviewProvider repositoryConfigs={repositoryConfigs}>{element}</PrismicPreviewProvider>
  </PrismicProvider>
)
